import n from "./highrise987.mjs";
function t(o) {
  const {
    primaryColor: r,
    baseColor: e
  } = o;
  return {
    color: r,
    iconColor: e
  };
}
const i = {
  common: n,
  self: t
};
export {
  i as default,
  t as self
};
